import PropTypes from 'prop-types';
import { AlertCircle } from 'lucide-react';
import Modal from './Modal';
import { Button } from '../ui/Button';

function ConfirmModal({
  isOpen = false,
  onClose,
  onConfirm,
  title = 'Confirmation',
  description = 'Êtes-vous sûr ?',
  confirmText = 'Confirmer',
  cancelText = 'Annuler',
  variant = 'default',
  loading = false,
}) {
  const variantConfig = {
    default: {
      icon: AlertCircle,
      iconColor: 'text-blue-600',
      buttonVariant: 'default',
    },
    danger: {
      icon: AlertCircle,
      iconColor: 'text-red-600',
      buttonVariant: 'destructive',
    },
    warning: {
      icon: AlertCircle,
      iconColor: 'text-amber-600',
      buttonVariant: 'default',
    },
  };

  const config = variantConfig[variant] || variantConfig.default;
  const Icon = config.icon;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      closeOnBackdrop={!loading}
    >
      <div className="flex gap-4">
        <div className={`flex-shrink-0 ${config.iconColor}`}>
          <Icon className="h-6 w-6" />
        </div>
        <div className="flex-1">
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
      </div>

      <div className="flex gap-3 justify-end mt-6">
        <Button
          variant="outline"
          onClick={onClose}
          disabled={loading}
        >
          {cancelText}
        </Button>
        <Button
          variant={config.buttonVariant}
          onClick={onConfirm}
          disabled={loading}
          className="gap-2"
        >
          {loading && <span className="inline-block animate-spin">⏳</span>}
          {confirmText}
        </Button>
      </div>
    </Modal>
  );
}

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'danger', 'warning']),
  loading: PropTypes.bool,
};

ConfirmModal.defaultProps = {
  isOpen: false,
  title: 'Confirmation',
  description: 'Êtes-vous sûr ?',
  confirmText: 'Confirmer',
  cancelText: 'Annuler',
  variant: 'default',
  loading: false,
};

export default ConfirmModal;
